<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :large="large"
        :color="color"
        class="ml-3"
      >
        <v-icon>{{ icon }}</v-icon>
        <span>Importar Tarefas</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="6">
            <v-select
              id="solution-select"
              v-model="payload.solucao"
              item-text="nome"
              item-value="municipioSolucaoId"
              :items="solutionList"
              label="Solução"
              placeholder="Solução"
              :return-object=true
              @change="changeSolution"
            >
              <template slot="no-data">
                Nenhuma Solução retornada
              </template>
            </v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="6">
            <v-combobox
              v-model="payload.solucao.tarefas"
              :items="tarefas"
              chips
              clearable
              label="Tarefas"
              item-text="nome"
              item-value="tarefaId"
              multiple
            >
              <template slot="no-data">
                Nenhuma Tarefa retornada
              </template>
            </v-combobox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { taskAPI } from '@/modules/task'
import { cityTaskAPI, citySolutionAPI } from '@/modules/city'
import { mapActions } from 'vuex'

export default {
  name: 'AppModalImportGroupSolution',
  props: {
    large: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  data () {
    return {
      payload: {
        municipioId: this.$route.params.id,
        solucao: {
          tarefas: []
        }
      },
      dialog: false,
      solutionList: [],
      tarefas: []
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      this.setLoading(true)
      cityTaskAPI.addBySolucao(this.payload)
        .then(resp => {
          this.setLoading(false)
          this.$notification.success('Tarefas incluídas com sucesso')
          this.dialog = false
          this.$emit('onSave')
          this.getSolutions()
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao incluir tarefas')
        })
    },
    changeSolution () {
      this.setLoading(true)
      this.payload.solucao.tarefas = []
      taskAPI.getBySolucao(this.payload.solucao)
        .then(resp => {
          this.tarefas = resp.data
          this.payload.municipioSolucaoId = this.payload.solucao.municipioSolucaoId
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter tarefas')
        })
    },
    getSolutions () {
      citySolutionAPI.listByCity(this.$route.params.id)
        .then(resp => {
          this.solutionList = resp.data
        })
        .catch()
    }
  },
  mounted () {
    this.getSolutions()
  }
}
</script>
